/* eslint-disable no-console */
import { mapState } from 'vuex';
import { TimelineMax, Power1 } from 'gsap/dist/gsap'
import { fabric } from 'fabric'
import CONST from '@/utils/Constants'
import eventBus from '@/config/EventBus';
import ApiHelper from "@/helpers/ApiHelper";
import ErrorHelper from "@/helpers/ErrorHelper";
import LayoutTablet from "@/layouts/tablet/layout-tablet.vue"
import oButton from "@/objects/o-button/o-button.vue"
import oModal from "@/objects/o-modal/o-modal.vue"

export default {
  name: "vDraw",
  components: {
    "layout-tablet": LayoutTablet,
    "o-button": oButton,
    "o-modal": oModal
  },
  data() {
    return {
      canvas: null,
      file: null,
      pusher: null,
      history: [],
      showColor: false,
      showWidth: false,
      widths: CONST.VALUE.LINE_WIDTHS,
      width: {
        slug: 'xs',
        value: 5
      },
      colors: CONST.VALUE.COLORS,
      color: {
        slug: 'black',
        hex: '#000000'
      },
      stopDrawing: false,
      icon: null,
      iconPosition: null,
      submitted: false
    }
  },
  computed: {
    ...mapState(['locale']),
    content() {
      return this.$store.getters.content;
    }
  },
  methods: {
    initializeCanvas() {
      this.canvas = new fabric.Canvas('drawing-canvas', {
        isDrawingMode: true,
        backgroundColor: 'white',
        height: window.innerHeight,
        width: window.innerWidth
      })

      const canvas = this.canvas;

      fabric.Object.prototype.transparentCorners = false;

      canvas.on('object:added', function () {
        if (!this.isRedoing) {
          this.h = []
        }
        this.isRedoing = false
      })

      if (canvas.freeDrawingBrush) {
        canvas.freeDrawingBrush.color = this.color.hex;
        canvas.freeDrawingBrush.width =
          parseInt(this.width.value, 10) || 5
      }
    },
    animate(ell, {from: from, to: to, duration: duration, delay: delay = 0}) {
      const tl1 = new TimelineMax();

      tl1.add('enter')
      tl1.fromTo(
        ell,
        duration,
        {
          bottom: from
        },
        {
          bottom: to,
          delay: delay,
          ease: Power1.out
        },
        'enter'
      )
    },
    toggleColor() {
      if(this.showWidth) {
        this.toggleWidth();
      }

      this.showColor = !this.showColor;

      if(this.showColor) {
        this.animate('#tools-colors', {from: 0, to: 100, duration: 0.2});

        for (var i = 0; i < document.getElementById("tools-colors").children.length; i++) {
          this.animate(document.getElementById("tools-colors").children[i], {from: -100, to: 0, duration: 0.2, delay: i * 0.03});
        }
      }else{
        this.animate('#tools-colors', {from: 100, to: 0, duration: 0.2});
      }
    },
    toggleWidth() {
      if(this.showColor) {
        this.toggleColor();
      }

      this.showWidth = !this.showWidth;

      if(this.showWidth) {
        this.animate('#tools-width', {from: 0, to: 100, duration: 0.2});

        for (var i = 0; i < document.getElementById("tools-width").children.length; i++) {
          this.animate(document.getElementById("tools-width").children[i], {from: -100, to: 0, duration: 0.2, delay: i * 0.03});
        }
      }else{
        this.animate('#tools-width', {from: 100, to: 0, duration: 0.2});
      }
    },
    setColor(e) {
      this.color.slug = e.target.getAttribute('value');
      this.color.hex = this.colors[e.target.getAttribute('value')];
    },
    setWidth(e) {
      this.width.slug = e.target.getAttribute('value');
      this.width.value = this.widths[e.target.getAttribute('value')];
    },
    deleteDrawing() {
      this.canvas.clear()
    },
    stop() {
      eventBus.$emit(CONST.EVENT.DRAWING.STOPPED);
    },
    submitDrawing() {
      let _this = this;

      if(!this.submitted) {
        this.submitted = true;
        this.icon = ' ';
        this.iconPosition = 'left';
        this.$store.commit('drawing', this.canvas.toDataURL());

        document.getElementById('drawing-canvas').toBlob(function(blob) {
          let file = new File([blob], "capture.png", {
            type: 'image/png'
          });

          const formData = new FormData();
          formData.append("file", file);

          ApiHelper.post(CONST.API.ROUTE.DRAWING.CREATE, formData, {headersType: 'multipart'})
          .then(() => {
            _this.submitted = false;
            _this.icon = null;
            _this.iconPosition = null;
            _this.$router.push({ name: 'drawing-ready'});
          })
          .catch(error => {
              ErrorHelper.catch(error, this);
          });
        });
      }

    },
    previous() {
      if (this.canvas._objects.length > 0) {
        this.history.push(this.canvas._objects.pop())
        this.canvas.renderAll()
      }
    },
    next() {
      if (this.history.length > 0) {
        this.isRedoing = true
        this.canvas.add(this.history.pop())
      }
    }
  },
  watch: {
    'color.hex': function (value) {
      this.canvas.freeDrawingBrush.color = value;
    },
    'width.value': function (value) {
      this.canvas.freeDrawingBrush.width = parseInt(value, 10) || 1;
    }
  },
  mounted() {
    this.initializeCanvas();
  }
}
